export default {
    authority: {
        method: "POST",
        url: "/sortingCityAdmin/gov/authority-list",
        name: "权限列表"
    },
    category: {
        method: "POST",
        url: "/sortingAdmin/waste/big-category",
        name: "品类大类"
    },
    bankList: {
        method: "POST",
        url: "/common/category/bank-list",
        name: "银行列表"
    },
    logout: {
        method: "POST",
        url: "/sortingCityAdmin/user/logout",
        name: "登出"
    },
    cityList: {
        method: "POST",
        url: "/common/address/city",
        name: "省、市、区、街道、社区列表"
    },
    streetList: {
        method: "POST",
        url: "/common/address/street-query",
        name: "街道、社区列表"
    },
    parentCategory: {
        method: "POST",
        url: "/common/sorting/parent-category",
        name: "分拣中心大类"
    },
    brokeCategory: {
        method: "POST",
        url: "/common/sorting/broke-category",
        name: "分拣中心小类"
    },
    excelList: {
        method: "POST",
        url: "/sortingCityAdmin/excel/download",
        name: "导出列表"
    },
    deleteExcel: {
        method: "POST",
        url: "/sortingCityAdmin/excel/delete-download",
        name: "取消下载"
    },
    getScreenCode: {
        method: "POST",
        url: "/sortingCityAdmin/user/screen-get-code",
        name: "获取验证令牌"
    },
};
